/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Connect_HelpInputs */

const en_ui_intervals_connect_help = /** @type {(inputs: Ui_Intervals_Connect_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find it under Developer Settings`)
};

const de_ui_intervals_connect_help = /** @type {(inputs: Ui_Intervals_Connect_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu finden unter Developer Settings`)
};

/**
* | output |
* | --- |
* | "Find it under Developer Settings" |
*
* @param {Ui_Intervals_Connect_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_connect_help = /** @type {((inputs?: Ui_Intervals_Connect_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Connect_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_connect_help(inputs)
	return de_ui_intervals_connect_help(inputs)
});